import { z } from 'zod';
import { baseSchema, baseFESchema } from '../base.domain.js';
import { objectIdSchema, isValidObjectIdSchema } from '../../utils/index.js';

const topicSchema = baseSchema.extend({
  short_code: z.string().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  grade: z.string().optional(),
  subject: z.string().optional(),
  chapter: z.string().optional(),
  curriculum: objectIdSchema.optional()
});
const topicFESchema = baseFESchema.merge(topicSchema.extend({
  curriculum: isValidObjectIdSchema.optional()
}));

export { topicFESchema, topicSchema };
